namespace GeniuzPOS.InventoryReport {
    export interface IcReport08Form {
        SkuCode: Serenity.StringEditor;
        SkuDesc: Serenity.StringEditor;
        QtyOnhand: Serenity.DecimalEditor;
        Countt: Serenity.IntegerEditor;
        DtList: Serenity.StringEditor;
    }

    export class IcReport08Form extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport08';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcReport08Form.init)  {
                IcReport08Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(IcReport08Form, [
                    'SkuCode', w0,
                    'SkuDesc', w0,
                    'QtyOnhand', w1,
                    'Countt', w2,
                    'DtList', w0
                ]);
            }
        }
    }
}
